import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Performance › Analytics (leaf).
export const salesAnalytics: ContentPage = {
  slug: "sales-performance/analytics",
  template: "hrmsFeature",
  seo: {
    title: "Sales Analytics - Analyze Performance & Trends | GetBiz CRM",
    description: "Understand what drives revenue with GetBiz CRM sales analytics. Analyze performance by rep, product and region to coach and grow.",
    keywords: ["sales analytics", "sales performance analytics", "crm analytics", "sales insights"],
    ogImage: "/assets/data/seoimages/analytics.webp",
  },
  leaf: {
    hero: {
      caption: "Analytics",
      title: "Analyze What Actually Drives Sales",
      description: "Dig into performance across reps, products and regions to understand the behaviors and deals that drive revenue.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Analytics",
      bullets: [
        { title: "Rep Performance", description: "Compare activity and results across the team." },
        { title: "Product & Region", description: "See what sells, where and to whom." },
        { title: "Trend Analysis", description: "Spot momentum and seasonality early." },
        { title: "Actionable Insight", description: "Turn analysis into coaching and strategy." },
      ],
      image: "/assets/images/img/product/crm/analytics-sub-lead-image.webp",
      imageAlt: "Analytics — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Performance",
      description: "Analytics connects to every other part of Sales Performance in GetBiz CRM.",
    },
    cards: [
      { title: "Forecasting", href: "/crm-software/sales-performance/forecasting/", description: "Build data-driven forecasts from your live pipeline, so leadership always has an accurate view of what will close.", image: "/assets/images/img/product/crm/forecasting.webp", imageAlt: "GetBiz CRM forecasting" },
      { title: "Multiple Currencies", href: "/crm-software/sales-performance/multiple-currencies/", description: "Quote, close and report across currencies with live exchange rates.", image: "/assets/images/img/product/crm/multiple-currencies.webp", imageAlt: "GetBiz CRM multiple currencies" },
      { title: "Visitor Tracking", href: "/crm-software/sales-performance/visitor-tracking/", description: "Identify the companies browsing your site, see what they view, and turn anonymous traffic into warm, timely outreach.", image: "/assets/images/img/product/crm/visitor-tracking.webp", imageAlt: "GetBiz CRM visitor tracking" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Analytics in action.",
    relatedBlogs: "static",
    metaKey: "sales-performance-analytics",
  },
  sections: [],
};
